import script from "./Item.vue?vue&type=script&setup=true&lang=js"
export * from "./Item.vue?vue&type=script&setup=true&lang=js"

import "./Item.vue?vue&type=style&index=0&id=e0ff7cac&lang=css"

const __exports__ = script;

export default __exports__